import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getEtiquetasComidas,
  insertEtiquetasComidas,
  updateEtiquetasComidas,
  deleteEtiquetasComidas,
  getEtiquetasComidasById,
} from 'services/reportes'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_ETIQUETAS_COMIDAS(action) {
  try {
    const etiquetasComidas = yield call(getEtiquetasComidas, action.payload)
    if (etiquetasComidas.ok) {
      yield put({
        type: actions.ETIQUETA_COMIDA_LOAD_SUCCEEDED,
        payload: etiquetasComidas.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar los Etiquetas Comidas')
      put({
        type: actions.ETIQUETA_COMIDA_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.ETIQUETA_COMIDA_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_ETIQUETA_COMIDA(action) {
  try {
    const etiquetasComidas = yield call(getEtiquetasComidasById, action.id)
    if (etiquetasComidas.ok) {
      yield put({
        type: actions.ETIQUETA_COMIDA_LOAD_SUCCEEDED,
        payload: etiquetasComidas.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar los Etiqueta Comida')
      put({
        type: actions.ETIQUETA_COMIDA_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.ETIQUETA_COMIDA_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_ETIQUETA_COMIDA(action) {
  try {
    const etiquetasComidas = yield call(insertEtiquetasComidas, action.payload)
    if (etiquetasComidas.ok) {
      putMessage(messageType.SUCCESS, 'Etiqueta Comida creado correctamente')
      yield put({
        type: actions.ETIQUETA_COMIDA_INSERT_SUCCEEDED,
        payload: etiquetasComidas.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Etiqueta Comida')
      yield put({
        type: actions.ETIQUETA_COMIDA_INSERT_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Etiqueta Comida')
    yield all([
      put({
        type: actions.ETIQUETA_COMIDA_INSERT_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_ETIQUETA_COMIDA(action) {
  try {
    const etiquetasComidas = yield call(updateEtiquetasComidas, action.payload)
    if (etiquetasComidas.ok) {
      putMessage(messageType.SUCCESS, 'Etiqueta Comida modificado correctamente')
      yield put({
        type: actions.ETIQUETA_COMIDA_UPDATE_SUCCEEDED,
        payload: etiquetasComidas.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Etiqueta Comida')
      yield put({
        type: actions.ETIQUETA_COMIDA_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Etiqueta Comida')
    yield all([
      put({
        type: actions.ETIQUETA_COMIDA_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_ETIQUETA_COMIDA(action) {
  try {
    const etiquetasComidas = yield call(deleteEtiquetasComidas, action.id)
    if (etiquetasComidas.ok) {
      putMessage(messageType.SUCCESS, 'Etiqueta Comida eliminado correctamente')
      yield put({
        type: actions.ETIQUETA_COMIDA_DELETE_SUCCEEDED,
        id: action.id,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Etiqueta Comida')
      yield put({
        type: actions.ETIQUETA_COMIDA_DELETE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Etiqueta Comida')
    yield all([
      put({
        type: actions.ETIQUETA_COMIDA_DELETE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.ETIQUETA_COMIDA_LOAD_REQUESTED, GET_ETIQUETAS_COMIDAS),
    takeEvery(actions.ETIQUETA_COMIDA_INSERT_REQUESTED, INSERT_ETIQUETA_COMIDA),
    takeEvery(actions.ETIQUETA_COMIDA_UPDATE_REQUESTED, UPDATE_ETIQUETA_COMIDA),
    takeEvery(actions.ETIQUETA_COMIDA_DELETE_REQUESTED, DELETE_ETIQUETA_COMIDA),
  ])
}
